module.exports = __webpack_public_path__ + "img/linked.538892f.svg";